// Bootstrap Icons name per public.modules.code, for the app tiles on Home and Pricing.
// A code missing here (a new module) falls back to the generic grid icon.
const APP_ICON: Record<string, string> = {
  STORE: "box-seam",
  POS: "shop",
  HRM: "people",
  AMS: "bank",
  DOCS: "folder2-open",
  FILE: "folder2-open",
  ITAM: "pc-display",
  DESK: "headset",
  LABOR: "tools",
};

export const appIcon = (code?: string) => APP_ICON[(code || "").toUpperCase()] || "grid-3x3-gap";
